import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { LocaleContext } from "../../contexts/LocaleContext";

const BackButton = () => {
  const { t } = useContext(LocaleContext);
  const navigate = useNavigate();

  return (
    <button type="button" className="btn-secondary" onClick={() => navigate(-1)}>
      <i className="fas fa-arrow-left"></i> {t("back")}
    </button>
  );
};

export default BackButton;
